import { render, staticRenderFns } from "./modalCompletarRegistro.vue?vue&type=template&id=8d8dfbec&scoped=true"
import script from "./modalCompletarRegistro.vue?vue&type=script&lang=js"
export * from "./modalCompletarRegistro.vue?vue&type=script&lang=js"
import style0 from "./modalCompletarRegistro.vue?vue&type=style&index=0&id=8d8dfbec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8dfbec",
  null
  
)

export default component.exports